import React, { Component } from 'react';

export default class AppErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[AppErrorBoundary]', error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;

    const message = this.state.error?.message || String(this.state.error);

    return (
      <div className="fixed inset-0 bg-black text-zinc-200 flex items-center justify-center p-6">
        <div className="max-w-md w-full border border-yellow-600/40 rounded-md bg-zinc-950 p-5 shadow-xl">
          <p className="text-[10px] uppercase tracking-[0.18em] text-yellow-500/80">Something went wrong</p>
          <h1 className="text-sm font-semibold text-yellow-400 mt-1">MineDynamicsViewer hit an error</h1>
          <p className="text-xs text-zinc-400 mt-2 leading-relaxed">
            The 3D viewer crashed. Reload to continue. If this keeps happening, try Prepare Offline again
            or clear site data for this host.
          </p>
          <pre className="mt-3 max-h-28 overflow-auto text-[10px] text-zinc-500 bg-black/60 p-2 rounded border border-zinc-800">
            {message}
          </pre>
          <button
            type="button"
            className="mt-4 px-3 py-1.5 text-xs bg-yellow-500 text-black rounded font-semibold hover:bg-yellow-400"
            onClick={() => window.location.reload()}
          >
            Reload
          </button>
        </div>
      </div>
    );
  }
}
